import React, { useEffect } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";

export default function CanvasStep1(props) {
  const {
    dataStep1,
    setDataStep1,
    selectorSBU,
    fetchSelectorUnit,
    selectorUnit,
    loadingUnit,
    openCanvas,
    setOpenCanvas,
    fetchJadwalDokter,
    setLoadingLoad,
    setDataStep2,
    initStep2,
    setUnitJenis3,
  } = props;

  const SPECIAL_TODAY_H1_UNITS = ["A62", "P48", "G16", "G17", "G18"];

  const isSpecialTodayH1Unit = SPECIAL_TODAY_H1_UNITS.includes(dataStep1?.unit);
  const hariIni = moment().format("YYYY-MM-DD");
  const maxHari = isSpecialTodayH1Unit
    ? moment().add(1, "days").format("YYYY-MM-DD")
    : dataStep1?.sbu === "RSPG" && dataStep1?.unit !== "P37"
    ? moment().add(30, "days").format("YYYY-MM-DD")
    : dataStep1?.sbu === "RSPG" && dataStep1?.unit === "P37"
    ? moment().add(5, "days").format("YYYY-MM-DD")
    : moment().add(3, "days").format("YYYY-MM-DD");

  // === SATU-SATUNYA sumber kebenaran validasi tanggal ===
  const isDateInRange = (d) =>
    typeof d === "string" &&
    moment(d, "YYYY-MM-DD", true).isValid() &&
    d >= hariIni &&
    d <= maxHari;

  const tanggalValid = isDateInRange(dataStep1?.date);
  const tanggalDiLuarRentang = !!dataStep1?.date && !tanggalValid;
  const pesanTanggal = `Pendaftaran bisa dilakukan ${moment(hariIni).format(
    "DD/MM/YYYY"
  )} dan ${moment(maxHari).format("DD/MM/YYYY")}`;

  const bisaSimpan = !!dataStep1?.sbu && !!dataStep1?.unit && tanggalValid;

  // Bersihkan tanggal sisa (mis. dari state lama) yang di luar rentang saat
  // canvas dibuka atau SBU/unit berubah. Tidak dijalankan saat mengetik.
  useEffect(() => {
    if (dataStep1?.date && !isDateInRange(dataStep1.date)) {
      setDataStep1({ ...dataStep1, date: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openCanvas, dataStep1?.sbu, dataStep1?.unit]);

  // onChange sengaja tidak mereset nilai: saat mengetik tahun, browser memicu
  // onChange di setiap digit (0002, 0020, 0202, 2026). Validasi dilakukan lewat
  // isInvalid + tombol Simpan + guard di onClick.
  const handleDateChange = (e) => {
    setDataStep1({ ...dataStep1, date: e.target.value || "" });
  };

  const handleSimpan = () => {
    if (!bisaSimpan) return; // pengaman tambahan
    setDataStep2(initStep2);
    setOpenCanvas(false);
    setLoadingLoad(true);
    fetchJadwalDokter();
  };

  return (
    <Offcanvas
      show={openCanvas}
      onHide={() => setOpenCanvas(false)}
      key="filter"
      placement="bottom"
      name="filter"
      style={{ zIndex: 99999, minHeight: "65%" }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Ubah Tujuan dan Tanggal</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Rumah Sakit / Klinik Tujuan</Form.Label>
            <Select
              styles={{
                color: "black",
              }}
              id="sbu"
              name="sbu"
              options={selectorSBU}
              isDisabled={!!dataStep1?.sbu}
              value={selectorSBU.find((find) => find?.value === dataStep1?.sbu)}
              onChange={(e) => {
                fetchSelectorUnit(e.value);
                setDataStep1({
                  ...dataStep1,
                  sbu: e.value,
                  sbuname: e.label,
                  unit: null,
                  unitname: null,
                  date: "",
                });
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Unit Rawat Jalan Tujuan</Form.Label>
            {dataStep1?.sbu ? (
              <Select
                styles={{
                  color: "black",
                }}
                id="unit"
                name="unit"
                options={selectorUnit}
                isLoading={loadingUnit}
                value={selectorUnit.find(
                  (find) => find?.value === dataStep1?.unit
                )}
                onChange={(e) => {
                  setDataStep1({
                    ...dataStep1,
                    unit: e.value,
                    unitname: e.label,
                    date: "",
                  });
                  setUnitJenis3(e.jenis3);
                }}
              />
            ) : (
              <Form.Control
                type="text"
                value="Pilih Rumah Sakit / Klinik Tujuan Terlebih Dahulu..."
                disabled
              />
            )}
          </Form.Group>

          {/* Satu input tanggal untuk semua SBU: min/max sudah dihitung di maxHari */}
          <Form.Group className="mb-3">
            <Form.Label>Tanggal</Form.Label>
            <Form.Control
              type="date"
              id="tanggal"
              name="tanggal"
              disabled={!dataStep1?.sbu || !dataStep1?.unit}
              value={dataStep1?.date || ""}
              onChange={handleDateChange}
              min={hariIni}
              max={maxHari}
              isInvalid={tanggalDiLuarRentang}
            />
            <Form.Control.Feedback type="invalid">
              {pesanTanggal}
            </Form.Control.Feedback>
          </Form.Group>
          <br />
          <div className="d-grid gap-2">
            <Button
              variant="warning"
              disabled={!bisaSimpan}
              onClick={handleSimpan}
            >
              Simpan
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}